export const getStartDateErrorMessage = state => state.validationDateRange.startDateErrorMessage;
export const getEndDateErrorMessage = state => state.validationDateRange.endDateErrorMessage;
